module.exports = __webpack_public_path__ + "images/emoji/crystal_ball.eb2018cb8cc7d7485a3d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/crystal_ball.png
// module id = Vp2/
// module chunks = 24